import { useState, useContext } from 'react';
import { IonContent, IonPage, IonGrid, IonRow, IonCol, IonInput, IonButton, useIonViewDidEnter } from '@ionic/react';
import Navbar from '../../components/Navbar';
import './styles.css';
import axios from 'axios';
import { ServerUrl, GetCurrentYear } from '../../constants';
import { AppContext } from "../../context/appContext";

const Home: React.FC = () => {
  const { CurrentUser } = useContext(AppContext);
  const token = CurrentUser ? CurrentUser.token : null;
  const isEscWorks = CurrentUser ? CurrentUser.isEscWorks : false;
  const groupName = CurrentUser ? CurrentUser.group : '';

  const currentYear = GetCurrentYear() - 2000;
  let current_year = currentYear + '-' + (currentYear + 1);
  let previous_year = (currentYear - 1) + '-' + currentYear;

  const currentFullYear = GetCurrentYear();
  let current_full_year = currentFullYear + ' - ' + (currentFullYear + 1);
  let previous_full_year = (currentFullYear - 1) + ' - ' + currentFullYear;

  const dataUrl = `${ServerUrl}/semiannually/2.6`;

  const data = [
    { name: "September - November" },
    { name: "December - February" },
    { name: "March - August" },
  ];

  const [CurrentData, SetCurrentData] = useState<Array<any>>([]);
  const [PreviousData, SetPreviousData] = useState<Array<any>>([]);

  const [CurrentParticipantsSum, SetCurrentParticipantsSum] = useState<string>('0');
  const [CurrentEventsSum, SetCurrentEventsSum] = useState<string>('0');

  const [PreviousParticipantsSum, SetPreviousParticipantsSum] = useState<string>('0');
  const [PreviousEventsSum, SetPreviousEventsSum] = useState<string>('0');

  useIonViewDidEnter(() => {
    axios.get(`${dataUrl}?year=${current_year}`, {
      headers: {
        'Authorization': "Bearer " + token,          
      }
    }).then(res => {
      if (res.data && res.data.length > 0) {
        SetCurrentData(res.data);
        SetCurrentParticipantsSum(getSum(res.data, "Participants"));
        SetCurrentEventsSum(getSum(res.data, "Events"));
      }
    }, err => {
      console.log("Fail to get data. " + JSON.stringify(err))
    });

    axios.get(`${dataUrl}?year=${previous_year}`, {
      headers: {
        'Authorization': "Bearer " + token,          
      }
    }).then(res => {
      if (res.data && res.data.length > 0) {
        SetPreviousData(res.data);
        SetPreviousParticipantsSum(getSum(res.data, "Participants"));
        SetPreviousEventsSum(getSum(res.data, "Events"));
      }
    }, err => {
      console.log("Fail to get data. " + JSON.stringify(err))
    });
  });

  const getData = (dataArray: Array<any>, quater: string, name: string) => {
    let num = 0;
    let element = dataArray.find(e => e.quater === quater);
    if (element) {
      if (name === "Participants") {
        num = parseFloat(element.participants);
      }
      else if (name === "Events") {
        num = parseFloat(element.events)
      }
    }
    return num;
  }

  const getSum = (data: Array<any>, name: string): string => {
    let sum = 0;
    if (name === "Participants") {
      data.forEach(item => { 
        let data = parseFloat(item.participants)
        if (!isNaN(data)) {
          sum += data;
        }
      });
    }
    else if (name === "Events") {
      data.forEach(item => {
        let data = parseFloat(item.events)
        if (!isNaN(data)) {
          sum += data;
        }
      });
      }
      return sum === 0 ? sum.toString() : sum.toLocaleString();
  }

  const saveData = (year: string, quater: string, name: string, value: any) => {
    axios.post(dataUrl, {"year": year, "quater": quater, "name": name, "value": value}, {
      headers: {
        'Authorization': "Bearer " + token,          
      }
    }).then(res => {
      if (year === current_year) {
        SetCurrentData(res.data);
        SetCurrentParticipantsSum(getSum(res.data, "Participants"));
        SetCurrentEventsSum(getSum(res.data, "Events"));
      } else {
        SetPreviousData(res.data);
        SetPreviousParticipantsSum(getSum(res.data, "Participants"));
        SetPreviousEventsSum(getSum(res.data, "Events"));
      }
    }, err => console.log("error"));
  }

  const onSaveExcel = () => {
    axios.get(`${dataUrl}/excel?current=${current_year}&previous=${previous_year}`, {
      headers: {
        'Authorization': "Bearer " + token,          
      },
      responseType: 'blob',
    }).then(res => {
      const url = window.URL.createObjectURL(new Blob([res.data],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download','Semi-Annual 2.6.xlsx');
        document.body.appendChild(link);
        link.click();
    }); 
  }

  return (
    <IonPage>
      <Navbar />
      <IonContent fullscreen>
          <div className='content-container'>
            <div style={{marginBottom: '10px', marginTop: '20px'}}>{groupName}</div>
            <div style={{marginBottom: '20px'}}>Indicator 2.6 - Number of Students Participating in Learning Through Regional Distance Learning and the Number of Distance Learning Events</div>
            <IonButton color="primary" style={{textTransform:'none'}} onClick = {onSaveExcel}>Export to Excel</IonButton>
          </div>
          <div className='flex-container'>
            <div style={{flexGrow: '1'}}>
              <IonGrid>
                <IonRow>
                  <IonCol offset="6" size="4" className='data-row right-border bottom-border table-header'>
                    <IonInput min='0'  value={current_full_year} readonly />
                  </IonCol>
                </IonRow>
                <IonRow className="header-row" style={{marginTop: '10px', marginBottom: '10px'}}>
                  <IonCol className='data-row no-border'>Reporting Period</IonCol>
                  <IonCol className='data-row no-border'>Student Participants</IonCol>
                  <IonCol className='data-row no-border'>Events</IonCol>
                </IonRow>
                {data.map((d, index) => {
                  return (
                    <IonRow key={index} className={(index % 2) === 0 ? "dark-row" : "light-row"}>
                      <IonCol className='data-row'><IonInput min='0'  value={d.name} readonly /></IonCol>
                      <IonCol className='data-row'>
                        {isEscWorks && <IonInput min='0'  type="number" step="1" value={getData(CurrentData, d.name, "Participants")} placeholder="" onBlur={(e) => {
                              saveData(current_year, d.name, "Participants", e.target.value)
                            }}>     
                        </IonInput>}
                        {!isEscWorks && <IonInput min='0'  readonly type="number" step="1" value={getData(CurrentData, d.name, "Participants")} placeholder="">     
                        </IonInput>}
                      </IonCol>
                      <IonCol className='data-row right-border'>
                        {isEscWorks && <IonInput min='0'  type="number" step="1" value={getData(CurrentData, d.name, "Events")} placeholder="" onBlur={(e) => {
                              saveData(current_year, d.name, "Events", e.target.value)
                        }}>     
                        </IonInput>}
                        {!isEscWorks && <IonInput min='0'  readonly type="number" step="1" value={getData(CurrentData, d.name, "Events")} placeholder="">     
                        </IonInput>}
                      </IonCol>
                    </IonRow>
                  )
                })}
                <IonRow>
                  <IonCol className='data-row top-border'></IonCol>
                  <IonCol className='data-row bottom-border table-header foot-text-color'>
                    <div style={{paddingRight: '14px'}}>
                      <IonInput min='0'  value={CurrentParticipantsSum} readonly />
                    </div>
                  </IonCol>
                  <IonCol className='data-row bottom-border right-border table-header foot-text-color'>
                    <div style={{paddingRight: '14px'}}>
                      <IonInput min='0'  value={CurrentEventsSum} readonly />
                    </div>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </div>
            <div style={{flexGrow: '1'}}>
              <IonGrid>
                <IonRow>
                  <IonCol offset="6" size="4" className='data-row right-border bottom-border table-header'>
                    <IonInput min='0'  value={previous_full_year} readonly />
                  </IonCol>
                </IonRow>
                <IonRow className="header-row" style={{marginTop: '10px', marginBottom: '10px'}}>
                  <IonCol className='data-row no-border'>Reporting Period</IonCol>
                  <IonCol className='data-row no-border'>Student Participants</IonCol>
                  <IonCol className='data-row no-border'>Events</IonCol>
                </IonRow>
                {data.map((d, index) => {
                  return (
                    <IonRow key={index} className={(index % 2) === 0 ? "dark-row" : "light-row"}>
                      <IonCol className='data-row'><IonInput min='0'  value={d.name} readonly /></IonCol>
                      <IonCol className='data-row'>
                        <IonInput min='0'  readonly type="number" step="1" value={getData(PreviousData, d.name, "Participants")} placeholder="" onBlur={(e) => {
                              saveData(previous_year, d.name, "Participants", e.target.value)
                            }}>     
                        </IonInput>
                      </IonCol>
                      <IonCol className='data-row right-border'>
                        <IonInput min='0'  readonly type="number" step="1" value={getData(PreviousData, d.name, "Events")} placeholder="" onBlur={(e) => {
                              // saveData(previous_year, d.name, "Events", e.target.value)
                        }}>     
                        </IonInput>
                      </IonCol>
                    </IonRow>
                  )
                })}
                <IonRow>
                  <IonCol className='data-row top-border'></IonCol>
                  <IonCol className='data-row bottom-border table-header foot-text-color'>
                    <div style={{paddingRight: '14px'}}>
                      <IonInput min='0'  value={PreviousParticipantsSum} readonly />
                    </div> 
                  </IonCol>
                  <IonCol className='data-row bottom-border right-border table-header foot-text-color'>
                    <div style={{paddingRight: '14px'}}>
                      <IonInput min='0'  value={PreviousEventsSum} readonly />
                    </div> 
                  </IonCol>
                </IonRow>
              </IonGrid>
            </div>
          </div>

      </IonContent>
    </IonPage>
  );
};

export default Home;
